$(() => {
  // 支払い方法変更時
  $('.js-conditions-container').on('change', '.js-payment-type', e => {
    const $paymentType = $(e.currentTarget);
    const paymentType = $paymentType.val();
    const $salary = $paymentType.closest('.js-condition').find('.js-salary');
    if (paymentType === 'on_percentage' || paymentType === 'negotiable') {
      $salary.val('').attr('readonly', true);
    } else {
      $salary.attr('readonly', false);
    }
  });

  // 追加ボタンの活性/非活性制御
  function enableAdditionalButton($container) {
    const elementCount = $container.find('.js-condition:visible').length;
    const limit = $container.data('limit');
    const $conditionAddition = $container.find('.js-condition-addition');
    if (elementCount >= limit) {
      $conditionAddition.attr('disabled', true).addClass('disabled');
    } else {
      $conditionAddition.attr('disabled', false).removeClass('disabled');
    }
  }

  // 条件追加時の処理
  $('.js-condition-addition').on('ajax:success', e => {
    const $conditionAddition = $(e.currentTarget);
    enableAdditionalButton($conditionAddition.closest('.js-conditions-container'));
  });

  // 条件削除時の処理
  $('.js-conditions-container').on('click', '.js-condition-unset', e => {
    const $conditionUnset = $(e.currentTarget);
    const $condition = $conditionUnset.closest('.js-condition');
    $condition.find('.js-destroy-input').val('1');
    $condition.hide('fast', () => {
      enableAdditionalButton($conditionUnset.closest('.js-conditions-container'));
    });
    return false;
  });
});
